<template>
  <div>
    <el-divider content-position="left">国民经济</el-divider>
    {{patentData.detail.nec}}
    <el-divider content-position="left">新兴产业</el-divider>
    <el-table :data="patentData.detail.eicf" border style="width: 100%">
      <el-table-column prop="title" label="名称">
      </el-table-column>
      <el-table-column prop="strategicEmergingIndustries" label="分类号">
      </el-table-column>
      <el-table-column prop="keywords" label="关键词">
      </el-table-column>
      <el-table-column prop="version" label="版本">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      patentData: null
    }
  },
  created() {

  },
  mounted() {
    this.patentData = this.data;
  },
  methods: {

  }
}
</script>

<style>
.shuoming-text {
  width: 100%;
  height: auto;
  font-size: 12px;
}
</style>